var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    ("" + _vm.cssPrefix),
    'sw-flexbox',
    'sw-flexbox--center-items',
    'sw-flexbox--end-justify' ]},[_vm._t("default",[_vm._v("Panel Footer")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }